export default "__VITE_ASSET__fb00dc13__"